import React from 'react';
const Logo = () => {
  return <div className="flex items-center" data-id="element-30">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fgvjAe5LXkghRJLv5MxD6Y/Logo_%282%29.png" alt="Maplewood-Care Logo" className="h-12 w-auto" data-id="element-31" />
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bGue7ufgpqrtAUhjzWRpjA/Main.png" alt="Maplewood-Care Mascot" className="h-16 w-auto ml-2" data-id="element-32" />
    </div>;
};
export default Logo;